/* eslint-disable no-nested-ternary */
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Task } from '@repo/shared';
import { getRouteApi } from '@tanstack/react-router';

import { useLeaderboard } from '@/api/generated';
import Header from '@/components/header';
import { Form } from '@/components/ui/form';
import { Spinner } from '@/components/ui/spinner';
import LeaderboardFilters from '@/routes/(app)/(leaderboards)/components/leaderboard-filters';
import { LeaderboardTable } from '@/routes/(app)/(leaderboards)/components/leaderboard-table';
import {
  LeaderboardFiltersSchema,
  leaderboardFiltersSchema,
} from '@/routes/(app)/(leaderboards)/lib/leaderboard-filters-schema';

const route = getRouteApi('/app/leaderboards');

export const Leaderboards = () => {
  const { t } = useTranslation();
  const { datasetIds, task } = route.useSearch();
  const form = useForm<LeaderboardFiltersSchema>({
    defaultValues: {
      datasetIds,
      task,
    },
    resolver: zodResolver(leaderboardFiltersSchema),
  });

  const { data, isLoading } = useLeaderboard(
    {
      datasetIds,
      task: task as unknown as Task,
    },
    {
      query: {
        enabled: Array.isArray(datasetIds) && task !== undefined,
      },
    }
  );

  return (
    <Form {...form}>
      <Header
        title={t('leaderboards.title')}
        description={t('leaderboards.description')}
      />

      <LeaderboardFilters />

      {isLoading ? <Spinner /> : data ? <LeaderboardTable data={data} /> : null}
    </Form>
  );
};
